module.exports = __webpack_public_path__ + "img/bg5.e9cd9524.png";